export default __webpack_public_path__ + "84e772a9601ff38b34f1b25a0ddccea1.svg";